import { supabase } from '../lib/supabase';

/**
 * Submit a builder application to Supabase
 * @param {Object} applicationData - The application form data
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const submitApplication = async (applicationData) => {
    try {
        // Validate required fields
        if (!applicationData.email) {
            return {
                success: false,
                error: 'Email is required',
            };
        }

        // Prepare data for insertion
        const dataToInsert = {
            linkedin_url: applicationData.linkedin || null,
            problem_obsession: applicationData.obsession || null,
            solution_thesis: applicationData.thesis || null,
            cold_start_strategy: applicationData.coldStart || null,
            email: applicationData.email,
            phone: applicationData.phone || null,
            status: 'pending',
        };

        // Insert into Supabase
        const { data, error } = await supabase
            .from('builder_applications')
            .insert([dataToInsert])
            .select();

        if (error) {
            console.error('Supabase error:', error);
            return {
                success: false,
                error: error.message || 'Failed to submit application',
            };
        }

        console.log('Application submitted successfully:', data);
        return {
            success: true,
            data: data[0],
        };
    } catch (error) {
        console.error('Unexpected error submitting application:', error);
        return {
            success: false,
            error: 'An unexpected error occurred. Please try again.',
        };
    }
};

/**
 * Get all applications (admin only - will fail due to RLS if not authenticated as admin)
 * @returns {Promise<{success: boolean, data?: Array, error?: string}>}
 */
export const getAllApplications = async () => {
    try {
        const { data, error } = await supabase
            .from('builder_applications')
            .select('*')
            .order('created_at', { ascending: false });

        if (error) {
            return {
                success: false,
                error: error.message,
            };
        }

        return {
            success: true,
            data: data || [],
        };
    } catch (error) {
        return {
            success: false,
            error: 'Failed to fetch applications',
        };
    }
};
